import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { HubspotIntegrationDestroyInput, HubspotIntegrationDestroyPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = HubspotIntegrationDestroyInput;
type TData = HubspotIntegrationDestroyPayload;

export const useHubspotIntegrationDestroy = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation hubspotIntegrationDestroy($input: HubspotIntegrationDestroyInput!) {
      hubspotIntegrationDestroy(input: $input) {
        success
        errors
        errorCode
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
